// LazyLoad - https://github.com/aFarkas/lazysizes
import 'lazysizes'
// import a plugin
import 'lazysizes/plugins/parent-fit/ls.parent-fit'

// Theme Functions
const fSmoothScroll = require('./utils/smooth-scroll')
// const ExampleModule = require('./components/example')
const fGsapController = require('./components/gsap-controller')
const fMobileMenu = require('./components/mobile-menu')
const fSwiper = require("./components/carousels");
import vueComponents from "./components/vue-components";
import observeAndExecute from "./utils/observe-and-execute";

document.addEventListener("DOMContentLoaded", () => {
    fSmoothScroll()

    fMobileMenu;
    fGsapController.init();
    
    vueComponents([
        {name: 'form-journey', file: () => import('./vue/form-journey.vue')},
    ]);

    window.addEventListener("resize", fMobileMenu);
    // fGsapController.init()
    
    const textDropdown = document.querySelectorAll('.text-dropdown__label');

    if (textDropdown) {
        textDropdown.forEach(item => {
            item.addEventListener('click', () => openDropdown(item));
        });
    }

    function openDropdown(clickedItem) {
        const dropdown = document.querySelector('.text-dropdown__items');
        if (dropdown && clickedItem) {
            dropdown.classList.toggle('active');
            clickedItem.classList.toggle('active');
        }
    }
    
    observeAndExecute(".swiper", {
        callback: () => fSwiper.init(),
        disconnect: true,
        observerOptions: {
            rootMargin: "200px",
        }
    })
    
    observeAndExecute("[data-lazy-src", {
        callback: el => el.setAttribute("src", el.dataset.lazySrc),
    })
})

document.addEventListener("cookieyes_consent_update", function (eventData)
{
    const data = eventData.detail;

    if(data.accepted.includes("analytics")){
        document.querySelector('#pi_tracking_opt_in_yes').click();
    }
});